import classNames from "classnames";

interface FormValidationErrorProps {
  errorId: string;
  className?: string;
  message: React.ReactNode;
}

export const ValidationError = (props: FormValidationErrorProps) => {
  return (
    <div
      id={props.errorId}
      className={classNames(
        "nsw-form__helper nsw-form__helper--error",
        props.className
      )}
    >
      <i
        tabIndex={-1}
        aria-hidden="true"
        className="material-icons nsw-material-icons"
      >
        error
      </i>
      <small className="font-weight-bold">{props.message}</small>
    </div>
  );
};
